import { Timestamp, TimeRange } from '@mi-front/core';
import { PersonAppearance, PersonLane } from './types';

function totalMs(items: PersonAppearance[]): number {
  return items.reduce((acc, a) => acc + (a.to - a.from), 0);
}

/** Recorta `items` a `[range.from, range.to]`, descartando los que no solapan. */
function clipToRange(items: PersonAppearance[], range: TimeRange<number>): PersonAppearance[] {
  return items
    .filter((a) => a.to > range.from && a.from < range.to)
    .map((a) => ({
      ...a,
      from: Math.max(a.from, range.from) as Timestamp,
      to: Math.min(a.to, range.to) as Timestamp,
    }));
}

/**
 * Recorta los intervalos de una lane al rango de foco y recalcula sus totales.
 * Devuelve `null` cuando ningún intervalo sobrevive al recorte.
 */
export function clipLaneToRange(lane: PersonLane, range: TimeRange<number>): PersonLane | null {
  const face = clipToRange(lane.face, range);
  const voice = clipToRange(lane.voice, range);
  if (face.length === 0 && voice.length === 0) {
    return null;
  }

  return {
    ...lane,
    face,
    voice,
    faceTotalMs: totalMs(face),
    voiceTotalMs: totalMs(voice),
    appearances: face.length + voice.length,
  };
}
